import React, { Fragment, useEffect, useState } from 'react';
import { Badge, Button, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import CustomDropdownMenu from '../common/CustomDropdownMenu';

const createMenu = (extraActions, closeMenu) => {
  return (
    <CustomDropdownMenu style={{ padding: '4px' }}>
      {extraActions.map((el, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={i}>{el.renderElement(closeMenu)}</Fragment>
      ))}
    </CustomDropdownMenu>
  );
};

const NavigationExecutionArea = ({ onExecute, extraActions, executeDisabled, count }) => {
  const [opened, setOpened] = useState(false);

  const closeMenu = () => setOpened(false);

  useEffect(() => {
    const clickHandler = (event) => {
      const el = event.target;
      const isCsvMenu = el.closest('.csv-options-menu') || el.closest('.csv-options-trigger');

      if (opened && !isCsvMenu) {
        closeMenu();
      }
    };

    document.addEventListener('click', clickHandler);

    return () => {
      document.removeEventListener('click', clickHandler);
    };
  }, [opened]);

  return [
    <Button
      key={0}
      type="primary"
      disabled={executeDisabled}
      onClick={() => onExecute()}
      style={{ marginLeft: 8, marginRight: -1 }}
    >
      Execute
    </Button>,
    extraActions ? (
      <div>
        <Badge count={count} style={{ backgroundColor: 'rgb(235 164 5)' }}>
          <Dropdown
            key={1}
            disabled={executeDisabled}
            dropdownRender={() => createMenu(extraActions, closeMenu)}
            trigger={['click']}
            open={opened}
          >
            <Button className="csv-options-trigger" onClick={() => setOpened(!opened)}>
              <DownOutlined />
            </Button>
          </Dropdown>
        </Badge>
      </div>
    ) : null,
  ];
};

export default NavigationExecutionArea;
